const WIDGET_MODES = {
    ADMIN: 'ADMIN',
};

const WIDGET_PROPERTY_DATA_TYPES = {
    TEXT: 'TEXT',
    BOOLEAN: 'BOOLEAN',
    NUMBER: 'NUMBER',
    DATE: 'DATE',
    LIST: 'LIST',
};

export { WIDGET_MODES, WIDGET_PROPERTY_DATA_TYPES };
